
require('./vehicles/overview');
require('./vehicles/features');
require('./vehicles/specs');
require('./vehicles/city');
require('./front/EstimatePayment');
require('./vehicles/colors');
require('./front/youtubeplayer');

window.Gallery = require('./vehicles/gallery');
window.AccessoriesGallery = require('./build-and-prices/AccessoriesGallery');
